import React from 'react';
import PropTypes from 'prop-types';
import update from 'immutability-helper';

import assign from 'object-assign';
import Moment from 'moment';
import MenuItem from 'material-ui/MenuItem';
import RaisedButton from 'material-ui/RaisedButton';
import AssetChip from '../Asset/AssetChip';
import SkillChip from "../Skill/SkillChip";

import ModuleActions from '../../actions/ModuleActionCreator';
import ModuleStore from '../../stores/ModuleStore';
import ModuleTypeStore from '../../stores/ModuleTypeStore';

import ThemeActions from '../../actions/ThemeActionCreator';
import ThemeStore from '../../stores/ThemeStore';

import AssetActions, { createAssetFromData, discardAssetDraft } from '../../actions/AssetActionCreator';
import AssetStore from '../../stores/AssetStore';
import SearchStore from '../../stores/SearchStore';

import EmailTemplateActions from '../../actions/EmailTemplateActionCreator';
import EmailTemplateStore from '../../stores/EmailTemplateStore';

import VendorActions from '../../actions/VendorActionCreator';
import VendorStore from '../../stores/VendorStore';

import EventActions from '../../actions/EventActionCreator';
import EventStore from '../../stores/EventStore';
import TextField from '../Common/TextField';
import SelectField from '../Common/SelectField';
import DatePicker from '../Common/DatePicker';
import TimePicker from '../Common/TimePicker';
import AutoComplete from '../Common/AutoComplete';
import { FormsyCheckbox as Checkbox } from 'formsy-material-ui';
import { Card, CardText } from 'material-ui/Card';
import CategorySelector from '../Category/CategorySelector';

import Form from '../Common/Form.react';
import { withId } from '../Common/Decorators';
import AssetEditDialog from '../Asset/AssetEditDialog';
import SelectSkill from '../Skill/SelectSkill';
import { SearchTypes } from '../../constants/CentricConstants';
import moment from 'moment';

const menuById = ({ id, name }) => <MenuItem key={id} value={id} primaryText={name} />;
const menuByName = ({ id, name }) => <MenuItem key={id} value={name} primaryText={name} />;

const midnight = () => {
    const hour = new Date();
    hour.setHours(0);
    hour.setMinutes(0);
    hour.setSeconds(0);

    return hour;
};

let timeout;

const styles = {
    floatingLabelStyle: {
        color: 'rgba(117, 117, 117, .50)'
    }
};
const validations = {
    name: {
        rules: {
            isWords: true,
            minLength: 2,
            maxLength: 80
        },
        error: 'Please use only numbers and letters, at least 2'
    },
    code: {
        rules: {
            maxLength: 16,
            matchRegexp: /^\S*$/
        },
        errors: {
            maxLength: 'Maximum length of 16 characters',
            matchRegexp: 'The code cannot contain spaces'
        }
    }
};
const requiredValidations = {
    isInt: true,
    inRange: (values, value) => (0 <= value && 100 >= value)
};
const validationErrors = {
    isInt: 'Please use only numbers',
    inRange: 'Please use a number from 0 to 100'
};

// todo: this should come from the type
const getAllowedFormTypes = (type) => {
    switch (type) {
        case 'resource':
            return ['text', 'document'];
        case 'video':
            return ['video'];
        case 'audio':
            return ['audio'];
        case 'e-learning':
            return ['e-learning'];
        default:
            return null;
    }
};

const ModuleForm = React.createClass({

    getInitialState() {
        return {
            details: {
                id: '',
                name: '',
                description: '',
                overview: '',
                capacity: 0,
                categoryId: this.props.categoryId,
                version: '',
                code: '',
                duration: '',
                lifetime: '',
                launchAsPopup: false,
                url: '',
                cost: '',
                price: '',
                type: (!!this.props.assetId ? 'resource' : 'classroom'),
                status: 'active',
                theme: 'default',
                visibility: 'private',
                isRepeatable: true,
                validFrom: new Date(),
                validTo: null,
                accessGroupId: null,
                accessGroup: 'Default',
                mediaId: this.props.assetId,
                mediaName: '',
                skillId: '',
                skillName: '',
                skillCode: '',
                emailTemplate: '',
                emailTemplateId: 0,
                required: 0,
                vendorId: '',
                vendor: '',
                eventAutoAttend: false,
                eventTemplateId: null,
                cpdCredits: null,
                published: false
            },
            showAddAsset: false,
            newAsset: null,
            typeOptions: [],
            statusOptions: [],
            themeOptions: [],
            visibilityOptions: ['private', 'public'],
            emailTemplateOptions: [],
            skill: null,
            categoryId: null,
            vendors: [],

            searchTerm: '',
            searchType: '',
            searchItems: [],

            minCapacity: 0,
            timeRegistration: (!!this.props.id) ? null : midnight(),
            timeStart: (!!this.props.id) ? null : midnight(),
            timeEnd: (!!this.props.id) ? null : midnight(),

            links: {
                list: '/dashboard/modules',
                settings: `/dashboard/module/${this.props.id}/settings`
            }
        };
    },

    componentWillMount() {
        this.onModuleTypeChange();
        this._onThemeChange();
        this._onEmailTemplateChange();
        this._onVendorChange();

        if (this.props.id) {
            this._onModuleChange();
            this.onEventChange();
        } else if (this.props.assetId) {
            this.onAssetLoad();
        }

    },

    componentDidMount() {
        this.listeners = [
            SearchStore.addListener(this.onSearchResults),
            ModuleTypeStore.addListener(this.onModuleTypeChange),
            ModuleStore.addListener(this._onModuleChange),
            ThemeStore.addListener(this._onThemeChange),
            EmailTemplateStore.addListener(this._onEmailTemplateChange),
            VendorStore.addListener(this._onVendorChange),
            AssetStore.addListener(this.onAssetLoad),
        ];

        ModuleActions.getSimplifiedStatusList();
        ModuleActions.getTypeOptions();

        if (this.props.id) {
            this.listeners.push(EventStore.addListener(this.onEventChange));
            ModuleActions.getById(this.props.id);
        } else if (this.props.assetId) {
            AssetActions.getById(this.props.assetId);
        }
        ThemeActions.getAll({ sort: 'listOrder' });
        EmailTemplateActions.getByType('module_joining_instructions');
        VendorActions.getAll();
    },

    componentWillUnmount() {
        this.listeners.forEach(listener => listener.remove());
    },


    render() {
        const formTitle = (this.props.id ? this.state.details.name : `New module (${this.state.details.type})`);
        const redirect = (this.props.id ? this.state.links.settings : this.state.links.list);

        if (this.state.details.validFrom) {
            this.state.details.validFrom = Moment(this.state.details.validFrom).toDate();
        }


        const canHaveMedia = (this.state.details.type !== 'classroom');

        let mediaChip;
        if (canHaveMedia && !!this.state.details.mediaId && !!this.state.details.mediaName) {
            mediaChip = (
                <AssetChip
                    data={{
                        id:   this.state.details.mediaId,
                        name: this.state.details.mediaName,
                        type: this.state.details.type
                    }}
                    onDelete={this.onAssetUnselect}
                    withTheme={!!this.state.details.published}
                />
            );
        }

        let accessGroups;
        if (!!this.context.auth.identity && !!this.context.auth.identity.accessGroups && 0 < this.context.auth.identity.accessGroups.length) {
            accessGroups = this.context.auth.identity.accessGroups.map(menuById);
        } else {
            accessGroups = [menuById({ key: this.state.details.accessGroupId, name: this.state.details.accessGroup })];
        }

        const shortForm = (this.state.details.type !== 'e-learning' && this.state.details.type !== 'classroom');

        return (
            <Form
                title={formTitle}
                onSave={this._onSave}
                redirectTo={redirect}
            >
                <Card className="cent-card">
                    <CardText>
                        <div className='cent-flex-row'>
                            <div className='cent-col-1'>
                                <TextField
                                    name="name"
                                    value={this.state.details.name}
                                    validations="minLength:2,maxLength:80"
                                    validationError="Please use only numbers and letters, at least 2"
                                    hintText="Name"
                                    floatingLabelText="Name"
                                    required
                                />
                            </div>
                            <div className='cent-col-1'>
                                <TextField
                                    name="description"
                                    value={this.state.details.description}
                                    multiLine={true}
                                    rowsMax={8}
                                    hintText="Description"
                                    floatingLabelText="Description"
                                />
                            </div>
                            {!shortForm && (
                                <div className='cent-col-1'>
                                    <TextField
                                        name="overview"
                                        value={this.state.details.overview}
                                        multiLine={true}
                                        rowsMax={8}
                                        hintText="Overview"
                                        floatingLabelText="Overview"
                                    />
                                </div>
                            )}
                            <div className='cent-col-1'>
                                <TextField
                                    name="url"
                                    value={this.state.details.url}
                                    validations="maxLength:250,isUrl"
                                    validationError="Please enter a valid URL"
                                    hintText="URL"
                                    floatingLabelText="URL"
                                />
                            </div>
                            <div className="cent-col-2">
                                <DatePicker
                                    name="validFrom"
                                    value={this.state.details.validFrom}
                                    hintText="Available from"
                                    floatingLabelText="Available from"
                                    maxDate={this.state.details.validTo}
                                    onChange={this.onValidFromChange}
                                    required
                                />
                            </div>
                            <div className="cent-col-2">
                                <DatePicker
                                    name="validTo"
                                    value={this.state.details.validTo}
                                    hintText="Available to"
                                    floatingLabelText="Available to"
                                    minDate={this.state.details.validFrom}
                                    onChange={this.onValidToChange}
                                />
                            </div>

                            <div className="cent-col-2">
                                <TextField
                                    name="lifetime"
                                    value={this.state.details.lifetime}
                                    validations="isInt"
                                    validationError="Lifetime in days"
                                    hintText="Valid for (days)"
                                    floatingLabelText="Valid for (days)"
                                />
                            </div>
                            <div className="cent-col-2">
                                <TextField
                                    name="duration"
                                    value={this.state.details.duration}
                                    validations="isInt"
                                    validationError="Duration in minutes"
                                    hintText="Duration (mins)"
                                    floatingLabelText="Duration"
                                    floatingLabelFixed={true}
                                />
                            </div>

                            {canHaveMedia && (
                                <div className="cent-col-2">
                                    <h2>Media</h2>
                                    {!this.state.details.mediaId && (
                                        <AutoComplete
                                            ref="media"
                                            floatingLabelText="Media"
                                            maxSearchResults={5}
                                            dataSource={this.state.searchItems}
                                            onUpdateInput={this.onAssetAutocomplete}
                                            onNewRequest={this.onAssetSelect}
                                            disabled={!!this.props.assetId}
                                        />
                                    )}
                                    <div className="cent-form-chips">
                                        {mediaChip}
                                    </div>
                                </div>
                            )}
                            {(!this.state.details.mediaId && canHaveMedia && !this.props.assetId) && (
                                <div className="cent-col-2"><br /><br /><br /><br />
                                    <RaisedButton label={this.state.assetDraft ? "Edit" : "New"} onTouchTap={this.newAsset} />
                                </div>
                            )}
                            {this.state.details.type === 'e-learning' && (
                                <div className="cent-col-1">
                                    <div className="cent-checkbox-wrapper">
                                        <div className="cent-checkbox-hint">Media options</div>
                                        <Checkbox
                                            name="launchAsPopup"
                                            value={this.state.details.launchAsPopup}
                                            label="Launch as popup"
                                        />
                                    </div>
                                </div>
                            )}
                        </div>
                        <h2>Classification</h2>
                        <div className='cent-flex-row'>
                            <div className='cent-col-1'>
                                {!this.props.typeId && (
                                    <SelectField
                                        name="type"
                                        value={this.state.details.type}
                                        hintText="Type"
                                        floatingLabelText="Type"
                                        floatingLabelFixed={true}
                                        onChange={this.onTypeChange}
                                        disabled={!!this.props.assetId}
                                        required
                                    >
                                        {this.state.typeOptions}
                                    </SelectField>
                                )}
                            </div>
                            <div className='cent-col-1'>
                                <CategorySelector
                                    onConfirmSelection={(categoryId) => this.setState({categoryId})}
                                    options={{canAddContent: true, limit: 0}}
                                    defaultCategoryId={!!this.props.id ? this.state.details.categoryId : null}
                                />
                            </div>
                            <div className="cent-col-2">
                                <TextField
                                    name="code"
                                    value={this.state.details.code}
                                    validations={validations.code.rules}
                                    validationErrors={validations.code.errors}
                                    hintText="Code"
                                    floatingLabelText="Code"
                                />
                            </div>
                            <div className="cent-col-2">
                                <TextField
                                    name="version"
                                    value={this.state.details.version}
                                    validations="isNumeric"
                                    validationError="Numbers only"
                                    hintText="Version"
                                    floatingLabelText="Version"
                                />
                            </div>
                        </div>
                        {!shortForm && (
                            <div>
                                <h2>Training</h2>
                                <div className='cent-flex-row'>
                                    <div className='cent-col-1'>
                                        {!this.state.skill
                                            ? <SelectSkill onSelect={(name, id) => this.setState({skill: {id, name}})}/>
                                            : <div>
                                                <div className="cent-checkbox-hint">Skill</div>
                                                <SkillChip skill={this.state.skill} onDelete={() => this.setState({skill: null})}/>
                                              </div>
                                        }
                                    </div>
                                    <div className="cent-col-2">
                                        <TextField
                                            name="cpdCredits"
                                            value={this.state.details.cpdCredits}
                                            validations="isNumeric"
                                            validationError="Please use only numbers"
                                            hintText="CPD Credits"
                                            floatingLabelText="CPD Credits"
                                            floatingLabelFixed={true}
                                        />
                                    </div>
                                    <div className="cent-col-2">
                                        <TextField
                                            name="required"
                                            value={this.state.details.required}
                                            validations={requiredValidations}
                                            validationErrors={validationErrors}
                                            hintText="Required pass mark"
                                            floatingLabelText="Required pass mark"
                                        />
                                    </div>
                                    {(this.state.details.type === 'e-learning') && (
                                        <div className="cent-col-1">
                                            <div className="cent-checkbox-wrapper">
                                                <div className="cent-checkbox-hint">Allow users to relaunch when completed</div>
                                                <Checkbox
                                                    name="isRepeatable"
                                                    value={this.state.details.isRepeatable}
                                                    label="Allow relaunch"
                                                />
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        )}
                        {this.state.details.type === 'classroom' && (
                            <div className="cent-flex-row">
                                {this.state.timeRegistration && (
                                    <TimePicker
                                        name="timeRegistration"
                                        floatingLabelText="Registration time"
                                        value={this.state.timeRegistration}
                                    />
                                )}
                                {this.state.timeStart && (
                                    <TimePicker
                                        name="timeStart"
                                        floatingLabelText="Start time"
                                        value={this.state.timeStart}
                                    />
                                )}
                                {this.state.timeEnd && (
                                    <TimePicker
                                        name="timeEnd"
                                        floatingLabelText="End time"
                                        value={this.state.timeEnd}
                                    />
                                )}
                                <div className="cent-col-2">
                                    <TextField
                                        name="capacity"
                                        value={this.state.details.capacity}
                                        validations="isInt"
                                        validationError="Please use only numbers"
                                        hintText="Capacity (Max)"
                                        floatingLabelText="Capacity (Max)"
                                        required
                                    />
                                </div>
                                <div className="cent-col-2">
                                    <TextField
                                        name="minCapacity"
                                        value={this.state.minCapacity}
                                        validations="isInt"
                                        validationError="Please use only numbers"
                                        hintText="Capacity (Min)"
                                        floatingLabelText="Capacity (Min)"
                                    />
                                </div>

                                <div className='cent-col-1'>
                                    <div className='cent-checkbox-wrapper'>
                                        <div className='cent-checkbox-hint'>Book users onto the first available event</div>
                                        <Checkbox
                                            name="eventAutoAttend"
                                            value={this.state.details.eventAutoAttend}
                                            label="Auto attendance"
                                        />
                                    </div>
                                </div>
                            </div>
                        )}
                        <h2>Notifications</h2>
                        <div className='cent-flex-row'>
                            <div className='cent-col-1'>
                                <SelectField
                                    name="emailTemplateId"
                                    value={this.state.details.emailTemplateId || 0}
                                    hintText="Email template"
                                    floatingLabelText="Email template"
                                >
                                    <MenuItem key="root" value={0} primaryText="(None)" />
                                    {this.state.emailTemplateOptions}
                                </SelectField>
                            </div>
                        </div>

                        <h2>Display</h2>
                        <div className='cent-flex-row'>
                            <div className="cent-col-2">
                                <SelectField
                                    name="visibility"
                                    value={this.state.details.visibility}
                                    hintText="Visibility"
                                    floatingLabelText="Visibility"
                                    floatingLabelFixed={true}
                                    floatingLabelStyle={styles.floatingLabelStyle}
                                    autoWidth={true}
                                    required
                                >
                                    {this.state.visibilityOptions.map((vis) => <MenuItem key={vis} value={vis} primaryText={vis} />)}
                                </SelectField>
                            </div>
                            <div className="cent-col-2">
                                <SelectField
                                    name="status"
                                    value={this.state.details.status}
                                    floatingLabelText="Status"
                                    floatingLabelFixed={true}
                                    floatingLabelStyle={styles.floatingLabelStyle}
                                    autoWidth={true}
                                    required
                                >
                                    {this.state.statusOptions}
                                </SelectField>
                            </div>
                            <div className='cent-col-1'>
                                {this.context.auth.isRoot() && (
                                    <SelectField
                                        name="accessGroupId"
                                        value={this.state.details.accessGroupId}
                                        floatingLabelText="Owner"
                                        floatingLabelFixed={true}
                                        floatingLabelStyle={styles.floatingLabelStyle}
                                        autoWidth={true}
                                    >
                                        {accessGroups}
                                    </SelectField>
                                )}
                                {!this.props.id && (
                                    <SelectField
                                        name="scope"
                                        floatingLabelText="Scope"
                                        floatingLabelFixed={true}
                                        floatingLabelStyle={styles.floatingLabelStyle}
                                        autoWidth={true}
                                    >
                                        {accessGroups}
                                    </SelectField>
                                )}
                            </div>
                            {!shortForm &&
                            <div className='cent-col-1'>
                                <SelectField
                                    name="theme"
                                    value={this.state.details.theme}
                                    floatingLabelText="Theme"
                                    floatingLabelFixed={true}
                                    floatingLabelStyle={styles.floatingLabelStyle}
                                    autoWidth={true}
                                    required
                                >
                                    {this.state.themeOptions}
                                </SelectField>
                            </div>
                            }
                        </div>
                        {!shortForm && (
                            <div>
                                <h2>Finance</h2>
                                <div className='cent-flex-row'>
                                    <div className='cent-col-1'>
                                        <SelectField
                                            name="vendorId"
                                            value={this.state.details.vendorId}
                                            floatingLabelText="Vendor"
                                            floatingLabelFixed={true}
                                            floatingLabelStyle={styles.floatingLabelStyle}
                                            autoWidth={true}
                                        >
                                            <MenuItem key="root" value={0} primaryText="(None)" />
                                            {this.state.vendors}
                                        </SelectField>
                                    </div>
                                    <div className="cent-col-2">
                                        <TextField
                                            name="cost"
                                            value={this.state.details.cost}
                                            validations="maxLength:7,isNumeric"
                                            validationError="Use only numbers (max 9999.99)"
                                            hintText="Cost"
                                            floatingLabelText="Cost"
                                            floatingLabelStyle={styles.floatingLabelStyle}
                                        />
                                    </div>
                                    <div className="cent-col-2">
                                        <TextField
                                            name="price"
                                            value={this.state.details.price}
                                            validations="maxLength:7,isNumeric"
                                            validationError="Use only numbers (max 9999.99)"
                                            hintText="Price"
                                            floatingLabelText="Price"
                                            floatingLabelStyle={styles.floatingLabelStyle}
                                        />
                                    </div>
                                </div>
                            </div>
                        )}
                    </CardText>
                </Card>
                {canHaveMedia && (
                    <AssetEditDialog
                        title="Create media"
                        onSave={this.saveAsset}
                        allowWysiwyg={true}
                        allowedTypes={getAllowedFormTypes(this.state.details.type)}
                    />
                )}
            </Form>
        );
    },

    _onSave(data) {
        data.type = this.state.details.type;
        let files;
        if (!!this.state.details.mediaId) {
            if (this.state.details.mediaId === 'draft') {
                const { asset, type, ...draft} = this.state.assetDraft;
                data.asset = draft;
                files = asset && [asset];
            } else {
                data.media = this.state.details.mediaId;
            }
        }
        data.skill = !!this.state.skill && this.state.skill.id || null;

        if (this.state.details.type === 'classroom') {
            data.timeRegistration = data.timeRegistration !== undefined ? moment(data.timeRegistration).format('HH:mm:ss') : null;
            data.timeStart = data.timeStart !== undefined ? moment(data.timeStart).format('HH:mm:ss') : null;
            data.timeEnd = data.timeEnd !== undefined ? moment(data.timeEnd).format('HH:mm:ss') : null;
        }

        data.validFrom = data.validFrom.toDateString();
        if (!!data.validTo) {
            data.validTo = data.validTo.toDateString();
        }

        data.categoryId = this.state.categoryId || this.state.details.categoryId;

        if (this.props.id) {
            return ModuleActions.update(this.props.id, data, files);
        } else {
            return ModuleActions.save(data, files);
        }
    },

    _onModuleChange() {
        let changes = {};

        if (this.props.id) {
            let details = ModuleStore.getById(this.props.id);
            if (details !== undefined) {
                changes.details = { $set: details };
                if (!!details.eventTemplateId) {
                    EventActions.getById(details.eventTemplateId);
                } else {
                    changes.timeRegistration = { $set: midnight() };
                    changes.timeStart = { $set: midnight() };
                    changes.timeEnd = { $set: midnight() };
                }
                if (!!details.skillId) {
                    changes.skill = { $set: {id: details.skillId, name: details.skillName}};
                }
            }
        }
        const statuses = ModuleStore.getStatusOptions();
        if (statuses !== undefined) {
            changes.statusOptions = { $set: statuses.map(({ name, label }) => <MenuItem key={name} value={name} primaryText={label} />) };
        }
        const state = update(this.state, changes);
        this.setState(state);
    },

    onModuleTypeChange() {
        const types = ModuleTypeStore.getAll();
        if (types !== undefined) {
            const changes = { typeOptions: { $set: types.map(menuByName) } };
            if (!!this.props.typeId) {  // preset type
                const type = types.find((t) => (!!t && t.id === this.props.typeId));
                if (type) {
                    changes.details = {
                        type: { $set: type.name }
                    };
                }
            }
            this.setState(update(this.state, changes));
        }
    },

    _onEmailTemplateChange() {
        const emailTemplates = EmailTemplateStore.getByType('module_joining_instructions');
        if (emailTemplates !== undefined) {
            const emailTemplateOptions = emailTemplates.map(menuById);
            this.setState({ emailTemplateOptions });
        }
    },

    _onThemeChange() {
        const themes = ThemeStore.getAll();
        if (themes !== undefined) {
            const themeOptions = themes.map(menuByName);
            this.setState({ themeOptions });
        }
    },

    onTypeChange({ target }, value) {
        if (value !== this.state.details.type) {
            const details = update(this.state.details, {
                type: { $set: value },
                mediaId: { $set: null },
                mediaName: { $set: null },
                launchAsPopup: { $set: (value === 'e-learning' ? false : null)}
            });
            this.setState({ details });
        }
    },

    onValidFromChange(e, value) {
        const details = update(this.state.details, { validFrom: { $set: new Date(value) } });
        this.setState({ details });
    },
    onValidToChange(e, value) {
        const details = update(this.state.details, { validTo: { $set: value && new Date(value) } });
        this.setState({ details });
    },

    onAssetAutocomplete(input) {
        clearTimeout(timeout);
        if (input !== undefined && input.length >= 2) {
            timeout = setTimeout(() => {
                AssetActions.search(input, { limit: 10 });
                this.setState({ searchTerm: input, searchType: 'asset' });
            }, 500);
        }
    },

    onSearchResults() {
        const search = SearchStore.getByKey(SearchTypes.ASSETS);
        if (!!search) {
            if (!!search.isFetching) { return this.setState({ isFetching: true }); } // guard: !isFetching

            let searchItems;
            switch (this.state.searchType) {
                case 'asset':
                    searchItems = this.parseAssetResults(search.results);
                    break;
            }

            this.setState(assign({}, this.state, { searchItems, isFetching: false }));
        }
    },

    parseAssetResults(results) {
        if (!results || results.length === 0) { return []; } // guard: results not empty

        let filter;
        switch (this.state.details.type) {
            case 'resource':
                filter = (asset) => (!!asset && (asset.type === 'text' || asset.type === 'document'));
                break;
            case 'video':
                filter = (asset) => (!!asset && asset.type === 'video');
                break;
            case 'audio':
                filter = (asset) => (!!asset && asset.type === 'audio');
                break;
            case 'e-learning':
                filter = (asset) => (!!asset && asset.type === 'e-learning');
                break;
            default:
                filter = () => true;
        }
        return results.filter(filter).slice(0, 10).map((asset) => {
            const name = `${asset.name} (${asset.type})`;
            return {
                id: asset.id,
                text: asset.name,
                value: <MenuItem key={asset.id} value={asset.id} primaryText={name} />
            };
        }, this);
    },

    onAssetLoad() {
        if (!this.props.assetId) { return; }
        const asset = AssetStore.getById(this.props.assetId);
        if (asset !== undefined) {
            const details = update(this.state.details, {
                name: { $set: this.state.details.name || asset.name },
                mediaName: { $set: asset.name }
            });
            this.setState({ details });
        }
    },

    onAssetSelect({ id, text }) {
        const details = {
            ...this.state.details,
            mediaId: id,
            mediaName: text
        };
        this.resetAutocomplete('media');
        this.setState({ details, assetDraft: null });
    },

    onAssetUnselect() {
        const details = {...this.state.details, mediaId: null, mediaName: null };
        this.setState({ details, assetDraft: null });
    },

    resetAutocomplete(ref) {
        const item = this.refs[ref];
        if (!!item) {
            item.setSearchTerm('');
        }
    },

    // asset creation stuff

    newAsset() {
        createAssetFromData(this.state.assetDraft);
    },
    saveAsset() {
        const draft = {...AssetStore.getDraft()};
        discardAssetDraft();
        this.setState({assetDraft: draft, details: {...this.state.details, mediaId: 'draft', mediaName: `${draft.name} [new ${draft.type.name}]`}});
    },

    // asset creation stuff ends

    _onVendorChange() {
        const vendors = VendorStore.getAll();
        if (vendors !== undefined) {
            const vendorOptions = vendors.map(menuById);
            this.setState({ vendors: vendorOptions });
        }
    },

    onEventChange() {
        let minCapacity, timeRegistration, timeStart, timeEnd;
        if (!!this.state.details.eventTemplateId) {
            const eventTemplate = EventStore.getById(this.state.details.eventTemplateId);
            if (!!eventTemplate) {
                minCapacity = eventTemplate.minCapacity;
                timeRegistration = new Date(eventTemplate.timeRegistration);
                timeStart = new Date(eventTemplate.timeStart);
                timeEnd = new Date(eventTemplate.timeEnd);
            }
        } else {
            minCapacity = 0;
            timeRegistration = midnight();
            timeStart = midnight();
            timeEnd = midnight();
        }

        this.setState({
            minCapacity,
            timeRegistration,
            timeStart,
            timeEnd
        });
    }
});

ModuleForm.contextTypes = {
    auth: PropTypes.object.isRequired
};

const getIds = ({ routeParams, location }) => ({
    id: Number(routeParams.id) || null,
    assetId: (!!routeParams.assetId && Number(routeParams.assetId)) || null,
    typeId: (!!routeParams.typeId && Number(routeParams.typeId)) || null,
    categoryId: (!!location.query.category && Number(location.query.category)) || null,
});

export default withId(ModuleForm, getIds);
